import {Button} from '@dropbox/dig-components/buttons';
import {Snackbar} from '@dropbox/dig-components/snackbar';
import {snackbarAtom} from 'atoms/snackbar';
import {ButtonLink} from 'components/DSYS/Link';
import {useAtom} from 'jotai';

import styles from './GlobalSnackbar.module.css';

export const GlobalSnackbar = ({bottomOffsetPx = 16}: {bottomOffsetPx?: number}) => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(snackbarAtom);

  if (!snackbarMessage) return null;

  const props: {timeout?: number} = {};
  if (snackbarMessage.timeout !== undefined) {
    props.timeout = snackbarMessage.timeout;
  }

  return (
    <div className={styles.wrapper} style={{bottom: bottomOffsetPx}}>
      <Snackbar
        open={!!snackbarMessage}
        preferComposition
        className={styles.snackbar}
        onRequestClose={() => {
          setSnackbarMessage(null);
        }}
        style={{zIndex: 999999}}
        {...props}
      >
        {snackbarMessage.accessory && (
          <Snackbar.Accessory>{snackbarMessage.accessory}</Snackbar.Accessory>
        )}
        <Snackbar.Content>
          <Snackbar.Message>{snackbarMessage.text}</Snackbar.Message>
        </Snackbar.Content>
        {snackbarMessage.action && (
          <Snackbar.Actions>
            {snackbarMessage.action.to ? (
              <ButtonLink
                to={snackbarMessage.action.to}
                openInNewTab={snackbarMessage.action.openInNewTab}
                variant={snackbarMessage.action.buttonVariant ?? 'transparent'}
                withIconStart={snackbarMessage.action.buttonIconStart}
                className={styles.button}
              >
                {snackbarMessage.action.text}
              </ButtonLink>
            ) : (
              <Button
                variant={snackbarMessage.action.buttonVariant ?? 'transparent'}
                onClick={snackbarMessage.action.onClick}
                withIconStart={snackbarMessage.action.buttonIconStart}
                className={styles.button}
              >
                {snackbarMessage.action.text}
              </Button>
            )}
          </Snackbar.Actions>
        )}
      </Snackbar>
    </div>
  );
};
